import React from "react";
import "./pages.css";
import "./pagesResponsiveStylesheet.css";
import SecurityDiagram from "../Assets/Images/Illustrations/security_diagram.png";
import PrivateModelDiagram from "../Assets/Images/Illustrations/private_model_diagram.png";
import MetaData from "../Components/MetaData/MetaData";
import Icon from "../Assets/IconLibrary/Icon";


export default class Security extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sectionList: [
                {
                    Title: "Private Large Language Models (LLMs)",
                    Diagram: PrivateModelDiagram,
                    Points: [
                        {
                            Name: "Confidentiality of your data is built-in with private models",
                            SubPoints: [],
                        },

                        {
                            Name: "Data never sent to the public LLMs like OpenAI",
                            SubPoints: [],
                        },

                        {
                            Name: "Data is fully private never leaving the premises",
                            SubPoints: [],
                        },

                        {
                            Name: "No training with your data",
                            SubPoints: [],
                        },

                    ],
                },
                {
                    Title: "Security",
                    Diagram: SecurityDiagram,
                    Points: [
                        {
                            Name: "ISO 27001",
                            SubPoints: [],
                        },
                        {
                            Name: "SOC 2 Type 2",
                            SubPoints: [],
                        },
                        {
                            Name: "State of the Art of Encryption",
                            SubPoints: [
                                "Data in Transit",
                                "Data at Rest"
                            ],
                        },
                    ],
                }
            ]
        }
    }


    getItem = (info) =>{
        return(
            <div className="security-item">
                <Icon name="check_shield" size={20} className="security-item-icon"/>
                <div className="security-item-text">{info}</div>
            </div>
        )
    }
    render() {
        return (
            <div className="security-layout">
                <MetaData keyword={"pricing"}/>
                <h1 className="section-title">
                    Security
                </h1>
                <div className="security-page-description">
                    <span className="security-page-highlight-description">
                        100% </span>
                    - Private, Secure, Confidential, Integral
                </div>
                {
                    this.state.sectionList.map((res,index)=>
                        <div className="security-page-section" key={index}>
                            <div className="security-section-left">
                                <div className="security-section-title">
                                    <Icon name="check_shield" size={40} className="security-section-title-icon"/>
                                    {res.Title}
                                </div>
                                <div className="security-section-body">
                                    {
                                        res.Points.map((info, id)=>
                                           <>
                                               { this.getItem(info.Name)}
                                               {
                                                   info.SubPoints !== undefined && info.SubPoints !== null && info.SubPoints.length !== 0?
                                                       <div className="security-section-sub-point-list">
                                                           {
                                                               info.SubPoints.map((subPoint, sid)=>
                                                                   this.getItem(subPoint)
                                                               )
                                                           }
                                                       </div>
                                                       :
                                                       null
                                               }
                                           </>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="security-section-right">
                                <img src={res.Diagram} alt={res.Title}/>
                            </div>
                        </div>
                    )
                }

            </div>

        )
    }
}